import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const couponApi = createApi({
  reducerPath: 'couponApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Coupon'],
  endpoints: (builder) => ({
    getCoupons: builder.query({
      query: (page = 1) => ({
        url: 'api/web/v1/site/coupon',
        method: 'GET',
        params: { page },
        tokenType: 'admin',
      }),
      providesTags: ['Coupon'],
    }),
    addCoupon: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/add-coupon',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Coupon'],
    }),
    deleteCoupon: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/delete-coupon',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Coupon'],
    }),
  }),
});

export const {
  useGetCouponsQuery,
  useAddCouponMutation,
  useDeleteCouponMutation,
} = couponApi;
